'use client';
import cn from 'classnames';

import './VideoHero.style.scss';

type VideoHeroProps = {
  className?: string;
  videoSrc: string;
  videoFileFormat: 'mp4' | 'mov' | 'webm';
  autoplay?: boolean;
  muted?: boolean;
  poster?: string;
  controls: boolean;
  loop?: boolean;
  playsInline?: boolean;
  allowDownload?: boolean;
  displayOptions: 'desktop-only' | 'mobile-only' | 'desktop-and-mobile';
};

function VideoHero(props: VideoHeroProps) {
  const {
    className = '',
    videoSrc,
    videoFileFormat,
    autoplay = false,
    muted = true,
    poster,
    controls,
    loop = false,
    playsInline = true,
    allowDownload = true,
    displayOptions
  } = props;
  return (
    <div className={cn('VideoHero', displayOptions, className)}>
      <video
        className={cn('VideoHero-video')}
        controls={controls}
        loop={loop}
        poster={poster}
        controlsList={allowDownload ? undefined : 'nodownload'}
        autoPlay={autoplay}
        muted={muted}
        playsInline={playsInline}
      >
        <source
          src={videoSrc}
          type={`video/${videoFileFormat}`}
        />
      </video>
    </div>
  );
}

export default VideoHero;
